import { render, staticRenderFns } from "./ReviewBox.vue?vue&type=template&id=396b4fc4&scoped=true&"
import script from "./ReviewBox.vue?vue&type=script&lang=js&"
export * from "./ReviewBox.vue?vue&type=script&lang=js&"
import style0 from "./ReviewBox.vue?vue&type=style&index=0&id=396b4fc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396b4fc4",
  null
  
)

export default component.exports